import _ from 'lodash';
import moment from 'moment';
import { BaseModel } from '../lib';
import _renameKeys from '../../lib/snowjs/lodash-mixins/rename-keys';


export default class MovieModel extends BaseModel {

  /*
  // fields
  id = null;
  title = null;
	release_date = null;
	poster_media_id = null;
	poster_url_path = null;
	imdb_id = null;
	imdb_img = null;
	youtube_code = null;
	rating = null;
	duration_mins = null;
	is3D = null; // int-boolean
	genre = null;
	cast = null;
	synopsis = null;
	comments = null;
	manager_notes = null;
	created = null;
	modified = null;
	deleted = null;
  */


  get durationMinsIntValue() {
    let value = this.duration_mins;
    if (value !== null && value !== undefined) {
      value = _.parseInt(value);
      if (!_.isFinite(value) || value <= 0) { value = null; }
    } else {
      value = null;
    }
    return value;
  }
  set durationMinsIntValue(value) {
    if (!_.isFinite(value)) {
      value = _.parseInt(value);
    }
    if (_.isFinite(value)) {
      value = Math.round(value);
    }
    if (!_.isFinite(value)) {
      value = null;
    }
    this.duration_mins = value;
  }

  get releaseYear() {
    return this._convertToDateString(this.releaseDateMomentValue, 'YYYY');
  }

  get releaseDateMomentValue() {
    return this._convertToMomentValue(this.release_date);
  }
  set releaseDateMomentValue(value) {
    this.release_date = this._convertToDateString(value);
  }

  get genreItems() {
    return this._convertDelimitedStringToStringList(this.genre);
  }
  set genreItems(value) {
    this.genre = this._convertStringListToDelimitedString(value);
  }

  get castItems() {
    return this._convertDelimitedStringToStringList(this.cast);
  }
  set castItems(value) {
    this.cast = this._convertStringListToDelimitedString(value);
  }

  get is3DBooleanValue() {
    return !!(_.toString(this.is3D) === '1');
  }
  set is3DBooleanValue(value) {
    this.is3D = (!!value)? '1': '0';
  }

  get posterMediaIdIntValue() {
    return this._convertToPositiveInteger(this.poster_media_id);
  }
  set posterMediaIdIntValue(value) {
    this.poster_media_id = this._convertPositiveIntegerToIntegerString(value);
  }

  get posterExtension() {
    return _.last(_.split(this.poster, '.')) || null;
  }

  getFormattedTitleAndYear() {
	  let title = this.title;
	  let releaseDate = this.releaseDateMomentValue;
    let year = (releaseDate && releaseDate.isValid())? releaseDate.format('YYYY'): null;

    if (!title) { title = 'Unknown Movie'; }
    year = (year)? ' (' + year + ')': '';

    return title + year;
  }

  getLegacyJsonObject() {
    let releaseDateStr = null;
    try {
      if (this.release_date) {
        releaseDateStr = moment(this.release_date).format('M/D/YYYY');
      }
    } catch (ex) {}
    let data = {
      id: _.parseInt(this.id),
      title: this.title,
      imdbId: this.imdb_id,
      releaseDate: releaseDateStr,
      rating: this.rating,
      durationMins: this.durationMinsIntValue,
      is3D: this.is3DBooleanValue,
      poster: null,
      youtubeCode: this.youtube_code,
      cast: this.cast,
      genre: this.genre,
      synopsis: this.synopsis,
      comment: this.comments,
    };
    return data;
    // return _.pick(this, 'id title imdb_id releaseDate rating duration_mins is3D poster youtubeCode cast genre synopsis comment'.split(' '));
  }

  toPublishedData() {
    let intKeys = 'id poster_media_id duration_mins'.split(' ');
    let boolKeys = 'is3D'.split(' ');
    let obj = _.toPlainObject(this);
    _.each(intKeys, k => {
      _.set(obj, k, _.parseInt(_.get(obj, k)));
    });
    _.each(boolKeys, k => {
      _.set(obj, k, this._convertToBoolean(_.get(obj, k)));
    });
    obj.poster = (this.releaseDateMomentValue || moment()).format('YYYY') + '/' + _.snakeCase(obj.title) + '.' + (this.posterExtension || 'jpg');
    obj.posterRes = '500x500';
    delete obj.manager_notes;
    _renameKeys(obj, { comments: 'comment', release_date: 'releaseDate', poster_media_id: 'posterMediaId', poster_publish_path: 'posterPublishPath', duration_mins: 'durationMins', imdb_id: 'imdbId', youtube_code: 'youtubeCode', imdb_img: 'imdbImg' });

    return obj;
  }
}
